import { useQuery } from "react-query";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { IAttributeModel } from "../../services/attribute-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseAllObjectAttributesParameters = {
    groupID: number,
    objectType: eLynxObjectTypeEnum,
} & BaseUseQueryParameters<IAttributeModel[] | undefined>;

export function useAllObjectAttributes({
    groupID,
    objectType,
    enabled,
    onError,
    onSuccess,
}: UseAllObjectAttributesParameters) {
    return useQuery<IAttributeModel[], RestError>(
        keys.allObjectAttributes(groupID, objectType),
        ({ signal }) => {
            return AttributeDataService.getObjectAttributes(
                groupID, 
                objectType,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity
        }
    );
}